module.exports = __webpack_public_path__ + "static/media/6.Grapes of Wrath (ft. Josh Biltekoff).81462882.mp3";